import { ReactNode } from 'react';

interface Props {
  render: ReactNode;
}

const RenderNode = ({ render }: Props) => {
  return render;
};

export default RenderNode;
